import { create } from 'apisauce';
import { buildMobileDialogMessage, MOBILE_DIALOG_TYPE } from '../utils/mobileCommunication';

const driverAppApi = create({
  baseURL: `${import.meta.env.VITE_DRIVER_APP_API}`,
  withCredentials: true,
});

driverAppApi.addRequestTransform((request) => {
  // Guard window access for SSR/test environments
  if (typeof window !== 'undefined' && window.location) {
    const urlParams = new URLSearchParams(window.location.search);
    const appVersion = urlParams.get('app_version');
    if (appVersion) {
      request.headers['X-App-Version'] = appVersion;
    }
  }
});

driverAppApi.addResponseTransform((response) => {
  if (response.status === 401 || response.status === 403) {
    if (typeof window !== 'undefined' && window.TSAMessageChannel) {
      const json = JSON.stringify(
        buildMobileDialogMessage({
          type: MOBILE_DIALOG_TYPE.ERROR,
          title: 'ERROR!',
          description: "Failed to authenticate! Your token has expired or you don't have permission to view this page.",
          redirectTo: '/back',
          okText: 'Got it',
        }),
      );
      window.TSAMessageChannel.postMessage(json);
    }

    if (!response.headers['no-redirect']) {
      // OAuth redirect disabled - mobile app context uses TSAMessageChannel for auth error handling instead
      // window.location.href = `${import.meta.env.VITE_OAUTH_URL}/login?next=${encodeURI(window.location.href)}`;
    }
  }

  if (response.problem === 'NETWORK_ERROR') {
    if (typeof window !== 'undefined' && window.TSAMessageChannel) {
      const json = JSON.stringify(
        buildMobileDialogMessage({ type: MOBILE_DIALOG_TYPE.ERROR, title: 'NETWORK ERROR!', description: 'Please check your internet connection.', redirectTo: '/back', okText: 'Got it' }),
      );
      window.TSAMessageChannel.postMessage(json);
    }
  }
});

export default driverAppApi;
